import { createElement } from 'react';
import { ArrayCards } from '@formily/antd';
import { useForm } from '@formily/react';
import { Alert } from 'antd';
import { syncUI, useSchema, mergeItems, reactNode2Schema, useSchemaField, } from '../../shared';
import ArrayCardsPreview from './preview';
const FormilyArrayCards = syncUI((props) => {
    const form = useForm();
    if (!form) {
        return createElement(Alert, { message: "formily component can only be used in formily form", type: "error" });
    }
    if (props.__designMode === 'design') {
        return createElement(ArrayCardsPreview, Object.assign({}, props));
    }
    const schema = useSchema(props, {
        'x-component': 'ArrayCards',
    });
    const { name } = props.fieldProps;
    const { schema: childrenSchema, componentsNameMap: componentMap } = reactNode2Schema(props.__origin_child || props.children);
    mergeItems(schema.properties[name], childrenSchema);
    componentMap.add('ArrayCards');
    const SchemaField = useSchemaField(componentMap, { ArrayCards });
    return createElement(SchemaField, { schema: schema });
});
export default FormilyArrayCards;
